export default __webpack_public_path__ + "assets/images/8c7ff8db83d8e8bef65d9417ff00b688.svg";